import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { METRIC, IMPERIAL } from '../../lib/types';
import { Document, Page, PDFViewer, Text, View, Image, Link as PDFLink } from '@react-pdf/renderer';
import './index.css';
import PDFReportStyles from './pdfreport.stylesheet';
import { regionIds } from '../../lib/localization/regionIds';
import { Link } from 'office-ui-fabric-react';

let logoImg = require('../../media/cultec-stormgenie-logo.png');
const styles = PDFReportStyles;

/**
 * PDF Report - pdf file for single beds Component
 */
class PDFReport extends PureComponent {
  getCurrentDate = () => {
    let date = new Date(),
      today = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    return today;
  };

  formatNum = (val) => {
    if (val && typeof val === 'number') {
      if (Number.isInteger(val)) {
        return Math.floor(val);
      } else {
        return val.toFixed(2);
      }
    } else {
      return val;
    }
  };

  hasOutletStructure = () => {
    if (this.props.hasOutlet) {
      return this.props.content[this.props.lang].yes;
    } else {
      return this.props.content[this.props.lang].no;
    }
  };

  render() {
    const {
      lbl,
      unit,
      lang,
      user,
      content,
      projectInfo,
      chamberType,
      averageCover,
      storageVolume,
      porousStoneBelow,
      porousStoneAbove,
      hasImperviousLiner,
    } = this.props;

    let crossSectionPrefix = this.props.lang.substring(0, 2);
    if (crossSectionPrefix === 'fr' && this.props.region.id === regionIds.europe) crossSectionPrefix += 'FR';

    const sectionImages = {
      'C-100HD': require(`../../media/chambers/${crossSectionPrefix}/C-100HD_CrossSection.png`),
      'R-150XLHD': require(`../../media/chambers/${crossSectionPrefix}/R-150XLHD_CrossSection.png`),
      'R-180HD': require(`../../media/chambers/${crossSectionPrefix}/R-180HD_CrossSection.png`),
      'R-280HD': require(`../../media/chambers/${crossSectionPrefix}/R-280HD_CrossSection.png`),
      'R-330XLHD': require(`../../media/chambers/${crossSectionPrefix}/R-330XLHD_CrossSection.png`),
      'R-300HD': require(`../../media/chambers/${crossSectionPrefix}/R-300HD_CrossSection.png`),
      'R-360HD': require(`../../media/chambers/${crossSectionPrefix}/R-360HD_CrossSection.png`),
      'R-902HD': require(`../../media/chambers/${crossSectionPrefix}/R-902HD_CrossSection.png`),
    };

    const img = sectionImages[chamberType.id];

    let project = this.props.project || projectInfo;

    let fullName = 'N/A';
    if (user) {
      fullName = `${user.givenName} ${user.surname}`;
    }

    const convertUnits = (value, unitType) => {
      let unitValue = 0;
      switch (unit) {
        case METRIC:
          switch (unitType) {
            case 'ft': // Feets to meters
              unitValue = parseFloat(Math.ceil(value * 0.3048 * 100) / 100).toFixed(2);
              break;
            case 'in': // Inches to milimeters
              unitValue = Math.ceil(Math.ceil(value * 25.4 * 100) / 100);
              break;
            case 'sf': //
              unitValue = parseFloat(Math.ceil((value / 10.764) * 100) / 100).toFixed(2);
              break;
            case 'cf': // Cubic feets to cubic meters
              unitValue = parseFloat(Math.ceil((value / 35.315) * 100) / 100).toFixed(2);
              break;
            case 'cy': // Cubic yards to cubic meters
              unitValue = parseFloat(Math.ceil((value / 1.308) * 100) / 100).toFixed(2);
              break;
            case 'sy': // Square yards to square meters
              unitValue = parseFloat(Math.ceil((value / 1.196) * 100) / 100).toFixed(2);
              break;
            default:
              unitValue = Math.ceil(value * 100) / 100;
              break;
          }
          break;
        case IMPERIAL:
          unitValue = this.formatNum(value);
          break;
        default:
          break;
      }
      return unitValue;
    };

    return (
      <PDFViewer style={styles.viewer}>
        <Document
          style={styles.document}
          onRender={this.handleOnRender}
          title={content[lang].adsPdfReport}
          author={content[lang].adsDesignTool}
          creator={content[lang].adsDesignTool}
          producer={content[lang].adsDesignTool}
          subject={content[lang].adsCalculationsReport}
          keywords={'ADS Design Tool, Advance Solutions, Report, PDF, Calculations'}>
          <Page>
            {/*HEADER IMAGE*/}
            <View style={styles.headerView}>
              <Image style={styles.logoImgStyle} src={logoImg} />
            </View>
            <View style={styles.sectionRow}>
              {/*USER INPUTS COL*/}
              <Text style={styles.titleText}>{content[lang].userInputs.toUpperCase()}</Text>
              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].projectName} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>{project.projectName}</Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].engineer} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>{fullName}</Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].projectLocation} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>{project.state}</Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].measurementType} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>{unit.charAt(0).toUpperCase() + unit.slice(1)}</Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].chamberModel} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>{chamberType.name}</Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].requiredStorageVolume} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {convertUnits(storageVolume, 'cf')} {lbl[unit].cf[lang]}
                  </Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].availableLengthPdf} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {convertUnits(this.props.availableLength, 'ft')} {lbl[unit].ft[lang]}
                  </Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].availableWidthPdf} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {convertUnits(this.props.availableWidth, 'ft')} {lbl[unit].ft[lang]}
                  </Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].stoneAboveChambersMsg}: </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {convertUnits(porousStoneAbove, 'in')} {lbl[unit].in[lang]}
                  </Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].stoneBelowChambersMsg}: </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {convertUnits(porousStoneBelow, 'in')} {lbl[unit].in[lang]}
                  </Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].baseStoneElevationPdf} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {convertUnits(this.props.baseStoneElevation, 'ft')} {lbl[unit].ft[lang]}
                  </Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].stonePorosityPdf} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>{this.formatNum(this.props.porosityPercent)}%</Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].maximumAllowableCover} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {convertUnits(this.props.calculations.baseStoneElevation + this.props.chamberType.maxCover, 'ft')}{' '}
                    {lbl[unit].ft[lang]}
                  </Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].minimumAllowableCover} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {convertUnits(
                      this.props.calculations.baseStoneElevation + this.props.chamberType.minInstalledDepth,
                      'ft',
                    )}{' '}
                    {lbl[unit].ft[lang]}
                  </Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].outletControlStructure} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>{this.hasOutletStructure()}</Text>
                </View>
              </View>
            </View>

            <View style={styles.sectionRow}>
              {/*RESULTS COL*/}
              <Text style={styles.titleText}>{content[lang].results}</Text>
              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].installedStorageVolume} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {convertUnits(this.props.calculations.totalStorageProvided, 'cf')} {lbl[unit].cf[lang]}
                  </Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].storageVolumePerChamber} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {convertUnits(this.props.chamberStorageVolume, 'cf')} {lbl[unit].cf[lang]}
                  </Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].chamberRows} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>{this.formatNum(this.props.calculations.numberOfRows) || 0}</Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].maximumLength}</Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {convertUnits(this.props.calculations.systemLength, 'ft') || 0} {lbl[unit].ft[lang]}
                  </Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].maximumWidth} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {convertUnits(this.props.calculations.systemWidth, 'ft') || 0} {lbl[unit].ft[lang]}
                  </Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].approxBedSizeRequired} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {convertUnits(this.props.calculations.rectangularFootprint, 'sf') || 0} {lbl[unit].sf[lang]}
                  </Text>
                </View>
              </View>
            </View>
            <View style={styles.sectionRow}>
              {/*SYSTEM COMPONENTS*/}
              <Text style={styles.titleText}>{content[lang].systemComponents}</Text>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].numberOfChambersRequired} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>{this.formatNum(this.props.calculations.requiredChambers) || 0}</Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].numberOfEndCapsRequired} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>{this.formatNum(this.props.calculations.requiredEndCaps) || 0}</Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].numberOfFeedConectorsRequired} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>{this.formatNum(this.props.numberOfFeedConnectors) || 0}</Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].amountOfStoneRequired} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {Math.ceil(convertUnits(this.props.calculations.amountOfStone / Math.pow(3, 3), 'cy')) || 0}{' '}
                    {lbl[unit].cy[lang]}
                  </Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].volumeOfExcavation} </Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {Math.ceil(convertUnits(this.props.calculations.totalExcavation / Math.pow(3, 3), 'cy')) || 0}{' '}
                    {lbl[unit].cy[lang]}
                  </Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].totalNonWovenPdf}</Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {/*{Math.ceil(convertUnits(( this.props.calculations.geotextileQuantities.nonWovenTotal || 0 )), "sy") || 0} {lbl[unit].squareYard[lang]}*/}
                    {Math.ceil(convertUnits(this.props.calculations.geotextileQuantities.nonWovenTotal, 'sy')) || 0}{' '}
                    {lbl[unit].sy[lang]}
                  </Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].woven}</Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {Math.ceil(convertUnits(this.props.calculations.geotextileQuantities.woven, 'ft')) || 0}{' '}
                    {lbl[unit].ft[lang]}
                  </Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].wovenIsolator}</Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {Math.ceil(convertUnits(this.props.calculations.geotextileQuantities.wovenIsolator, 'ft')) || 0}{' '}
                    {lbl[unit].ft[lang]}
                  </Text>
                </View>
              </View>

              <View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].totalWoven}</Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {Math.ceil(convertUnits(this.props.calculations.geotextileQuantities.wovenTotal, 'ft')) || 0}{' '}
                    {lbl[unit].ft[lang]}
                  </Text>
                </View>
              </View>

              {/*<View style={styles.rowView}>
                <View style={styles.innerLColView}>
                  <Text style={styles.tableTextBold}>{content[lang].imperviousLinerRequired}</Text>
                </View>
                <View style={styles.innerRColView}>
                  <Text style={styles.tableText}>
                    {Math.ceil(convertUnits(this.props.calculations.linerSqInchOverage, 'sy')) || 0}{' '}
                    {lbl[unit].sy[lang]}
                  </Text>
                </View>
              </View>*/}
            </View>

            {hasImperviousLiner ? (
              <View style={styles.rowView}>
                <View style={styles.fullColView}>
                  <Text style={styles.tableTextBold}>{content[lang].imperviousLinerNotes}</Text>
                  <Text style={styles.tableText}>
                    <PDFLink href="https://assets.ads-pipe.com/m/43dc1a1b8b189a34/original/TN-6-50-Thermoplastic-Liners-for-Detention-Systems.pdf">
                      {content[lang].technicalNote650}
                    </PDFLink>
                  </Text>
                  <Text style={styles.tableText}>{content[lang].technicalNotes}</Text>
                </View>
              </View>
            ) : null}

            <View style={styles.contentView}>
              <Image style={styles.sectionImgStyle} src={img} />
            </View>
            <View style={styles.linkSection}>
              <PDFLink style={styles.link} src="https://www.cultec.com">
                www.cultec.com
              </PDFLink>
            </View>
          </Page>
        </Document>
      </PDFViewer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lbl: state.localization.lbl,
    unit: state.localization.unit,
    globals: state.globals,
    lang: state.localization.lang,
    region: state.localization.region,
    project: state.project.project,
    user: state.authentication.user,
    calculations: state.calculations,
    content: state.localization.content,
    chamberType: state.globals.chamberType,
    projectInfo: state.project.projectInfo,
    hasOutlet: state.calculations.hasOutlet,
    parameters: state.calculations.parameters,
    systemWidth: state.calculations.systemWidth,
    averageCover: state.calculations.averageCover,
    systemLength: state.calculations.systemLength,
    storageVolume: state.calculations.storageVolume,
    availableWidth: state.calculations.availableWidth,
    availableLength: state.calculations.availableLength,
    porosityPercent: state.calculations.porosityPercent,
    porousStoneAbove: state.calculations.porousStoneAbove,
    porousStoneBelow: state.calculations.porousStoneBelow,
    chamberStorageVolume: state.globals.chamberType.storage,
    totalStorageProvided: state.calculations.totalStorageProvided,
    chamberEndCapTypeStorage: state.globals.chamberEndCapType.storage,
    hasImperviousLiner: state.calculations.hasImperviousLiner,
    baseStoneElevation: state.calculations.baseStoneElevation,
    numberOfFeedConnectors: state.chamberbed.feedConnectors.numberOfFeedConnectors,
  };
};

export default connect(mapStateToProps, {})(PDFReport);



// WEBPACK FOOTER //
// ./src/components/PDFReport/index.js